// 报告模块通用 echarts 封装：各模块直接调用 drawMeter / drawRadar / drawBroken / drawCake 即可
const echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/gauge');
require('echarts/lib/component/grid');
require('echarts/lib/chart/line');
require('echarts/lib/component/title');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/legend');
require('echarts/lib/chart/pie');
require('echarts/lib/component/markLine');
require('echarts/lib/chart/radar');

function ensureChart(id) {
    const dom = document.getElementById(id);
    if (!dom) return null;
    echarts.dispose(dom);
    return echarts.init(dom);
}

// 仪表盘（健康平衡度）
export function drawMeter(id, params = {}) {
    const chart = ensureChart(id);
    if (!chart) return;
    chart.setOption({
        series: [{
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            splitNumber: 0,
            axisLine: {
                lineStyle: {
                    width: 6,
                    color: params.color || [
                        [0.5, '#F36440'],
                        [0.65, '#F89143'],
                        [0.8, '#ECDB44'],
                        [0.9, '#5CC7BC'],
                        [1, '#83D186']
                    ]
                }
            },
            splitLine: {
                length: 20,
                lineStyle: { color: 'auto', width: 5 }
            },
            axisLabel: {
                color: '#464646',
                fontSize: 15,
                distance: -60,
                formatter: (value) => (value ? value : '')
            },
            detail: {
                fontSize: 30,
                offsetCenter: [0, '40%'],
                valueAnimation: true,
                formatter: () => '',
                color: 'auto'
            },
            data: [{ value: params.score }]
        }]
    });
}

// 雷达图（气血津液）
export function drawRadar(id, data) {
    const chart = ensureChart(id);
    if (!chart) return;
    chart.setOption({
        radar: {
            shape: 'circle',
            radius: '50%',
            indicator: [
                { name: '气血充盈度', max: 10 },
                { name: '气血运行度', max: 10 },
                { name: '津液代谢度', max: 10 },
                { name: '津液濡润度', max: 10 }
            ]
        },
        series: [{ type: 'radar', data: [{ value: data }] }]
    });
}

// 折线图
export function drawBroken(id, { date, data, max } = {}) {
    const chart = ensureChart(id);
    if (!chart) return;
    chart.setOption({
        xAxis: {
            type: 'category',
            data: date,
            axisTick: { alignWithLabel: true }
        },
        yAxis: { type: 'value', max },
        series: [{ data, type: 'line', symbolSize: 10 }]
    });
}

// 饼图
export function drawCake(id, data) {
    const chart = ensureChart(id);
    if (!chart) return;
    chart.setOption({
        tooltip: { trigger: 'item' },
        color: ['#F16B86', '#F99938', '#FABF38', '#68CBEE', '#6BD890'],
        series: [{
            name: '',
            type: 'pie',
            radius: '50%',
            data,
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }]
    });
}

//柱状图
function remToPx(rem) {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return Math.round(rem * rootFontSize);
}

export function pillar( id , name ,  data) {
    const chart = ensureChart(id);
    if (!chart) return null;
    chart.setOption({
    grid: {
        left: '10%',
        right: '12%',
        bottom: '40%',
        top: '10%'
    },
    xAxis: {
        type: 'category',
        data: name,
        axisLine: { lineStyle: { color: '#e5e7eb' } },
        axisTick: { lineStyle: { color: '#e5e7eb' } },
        axisLabel: {
        color: '#333',
        interval: 0,
        align: 'center',
        verticalAlign: 'top',
        margin: 10,
        fontSize: remToPx(0.38),
        lineHeight: remToPx(0.5)
        }
    },
    yAxis: {
        type: 'value',
        min: -100,
        max: 100,
        axisLine: { show: true, lineStyle: { color: '#e5e7eb' } },
        axisTick: { lineStyle: { color: '#e5e7eb' } },
        axisLabel: { color: '#999' },
        splitLine: { lineStyle: { color: '#f0f0f0' } }
    },
    series: [
        {
        type: 'line',
        data: [],
        z: 0,
        markLine: {
            silent: true,
            symbol: ['none', 'none'],
            lineStyle: { type: 'solid' },
            data: [
            {
                yAxis: 100,
                lineStyle: { color: '#e5e7eb', width: 1 },
                label: {
                formatter: '实',
                position: 'end',
                color: '#f5222d',
                fontSize: remToPx(0.28),
                offset: [0, 17]
                }
            },
            {
                yAxis: -100,
                lineStyle: { color: '#e5e7eb', width: 1 },
                label: {
                formatter: '虚',
                position: 'end',
                color: '#f5222d',
                fontSize: remToPx(0.28),
                offset: [0, -17]
                }
            },
            {
                yAxis: 50,
                lineStyle: { color: '#faad14', width: 1 },
                label: { show: false }
            },
            {
                yAxis: -50,
                lineStyle: { color: '#faad14', width: 1 },
                label: { show: false }
            },
            {
                yAxis: 0,
                lineStyle: { color: '#1890ff', width: 2 },
                label: { show: false }
            }
            ]
        }
        },
        {
        data: data,
        type: 'bar',
        z: 10,
        // 关闭柱子上分数显示
        label: { show: false },
        itemStyle: {
            color: (params) => {
            const v = params.data;
            if (v >= -10 && v <= 10) return '#52c41a';
            if ((v > 10 && v <= 50) || (v < -10 && v >= -50)) return '#faad14';
            return '#f5222d';
            }
        }
        }
    ]
    });
    return chart;
}

export default { drawMeter, drawRadar, drawBroken, drawCake , pillar };
